import { useState, useRef, useEffect } from 'react'
import { CalendarDays } from 'lucide-react'

function toDisplay(isoDate) {
  if (!isoDate) return ''
  const [y, m, d] = isoDate.split('-')
  return `${d}/${m}/${y}`
}

function toISO(display) {
  const match = display.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
  if (match) return `${match[3]}-${match[2]}-${match[1]}`
  return null
}

export default function DateInput({ value, onChange, className = '', inputClassName = '' }) {
  const hiddenRef = useRef()
  const [localText, setLocalText] = useState(toDisplay(value))
  const [isFocused, setIsFocused] = useState(false)

  // Sync from parent when not focused
  useEffect(() => {
    if (!isFocused) {
      setLocalText(toDisplay(value))
    }
  }, [value, isFocused])

  const handleTextChange = (e) => {
    const raw = e.target.value
    setLocalText(raw)
    const iso = toISO(raw)
    if (iso) onChange(iso)
  }

  const handleBlur = () => {
    setIsFocused(false)
    // On blur, if the text isn't a valid date, revert to the parent value
    const iso = toISO(localText)
    if (iso) {
      onChange(iso)
    } else {
      setLocalText(toDisplay(value))
    }
  }

  const handleFocus = () => {
    setIsFocused(true)
  }

  return (
    <div className={`relative inline-flex items-center gap-1 ${className}`}>
      <input
        type="text"
        value={localText}
        onChange={handleTextChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder="dd/mm/yyyy"
        className={inputClassName || 'bg-gray-800 border border-gray-700 rounded px-3 py-1.5 text-sm text-white w-[120px] outline-none focus:border-brand-500'}
      />
      <button
        type="button"
        onClick={() => hiddenRef.current?.showPicker?.()}
        className="text-gray-500 hover:text-brand-400"
      >
        <CalendarDays size={14} />
      </button>
      <input
        ref={hiddenRef}
        type="date"
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        className="absolute opacity-0 w-0 h-0 pointer-events-none"
        tabIndex={-1}
      />
    </div>
  )
}
